import { useContext } from 'react';

import { RenderingContext } from './rendering-context';

/**
 * Read the current rendering's `params` (Sitecore "rendering parameters" /
 * Sanity preset variants). Always typed at the call site.
 */
export const useParams = <T = Record<string, unknown>>(): T | undefined => {
  const rendering = useContext(RenderingContext);
  return rendering?.params as T | undefined;
};
